:host {
    display: block;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 10px 0;
}

.image {
    width: 110px;
    height: auto;
    float: left;
    margin-right: 20px;
}

.main-infos {
    min-height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.name {
    font-family: var(--ux-font);
    font-size: var(--ux-input-label-font-size);
    font-weight: var(--ux-input-label-font-weight);
    line-height: var(--ux-input-label-line-height);
}

.content {
    clear: both;
}

::slotted(*) {
    font-family: var(--ux-font);
}

@media (min-width: 768px) {
    :host {
        padding: 0 40px 40px 0;
    }

    .image {
        width: 120px;
    }

    .main-infos {
        min-height: auto;
        display: block;
    }

    .content {
        clear: none;
    }
}

@media (min-width: 1440px) {
    .image {
        width: 150px;
    }
}
